export default __webpack_public_path__ + "static/media/Leaderboard_img.ddf8e5bd.png";